import React from 'react'
import { ErrorCode, ErrorContainer, HomeButton } from '../style'
import { useLocation, useNavigate } from 'react-router-dom'
import { TriangleAlert } from 'lucide-react'

const NotFoundPage:React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  
  return (
    <ErrorContainer>
      <TriangleAlert size={100} style={{marginBottom: '10px'}}/>
      <ErrorCode>404</ErrorCode>
      <p>Página de endereço {`"${location.pathname}"`}, não encontrada.</p>
      <HomeButton onClick={() => navigate('/panel')}>Início</HomeButton>
    </ErrorContainer>
  )
}

export default NotFoundPage